class VideoComponent extends HTMLElement {
  constructor() {
    super()
    MinimogTheme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 0 })
  }

  init() {
    this.autoPlay = 'true' === this.dataset.autoPlay
    this.muted = 'true' === this.dataset.muted
    const deferredPoster = this.querySelector('[id^="Deferred-Poster-"]')
    if (this.autoPlay) {
      this.loadContent()
    } else {
      deferredPoster.addEventListener('click', this.loadContent.bind(this))
    }
  }

  loadContent() {
    const loaded = this.getAttribute('loaded')

    if (loaded) return

    const container = document.createElement('div')
    container.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

    this.setAttribute('loaded', true)

    const deferredElement = this.appendChild(container.querySelector('video, model-viewer, iframe'))
    this.deferredElement = deferredElement

    if (!this.autoPlay) {
      return
    }

    function playExternalVideo() {
      // Youtube and Vimeo
      const queryParam = this.deferredElement.src.indexOf('?') > -1 ? '&' : '?'
      this.deferredElement.src += queryParam + 'autoplay=1' + (this.muted ? '&mute=1' : '')
    }

    const isExternalVideo =
      this.deferredElement.classList.contains('js-youtube') || this.deferredElement.classList.contains('js-vimeo')

    if (isExternalVideo) {
      playExternalVideo.call(this)
      return
    }

    if (this.deferredElement.tagName === 'VIDEO') {
      this.deferredElement.play()
    }

    throw new Error('Unsupported video type')
  }
}

if (!customElements.get('video-component')) {
  customElements.define('video-component', VideoComponent)
}
